<template>


  <div class="modal">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <button @click="closeModal()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="wallet-balance-detail ">
            <div class="card">
              <div class="card-header">
                <div class="d-flex justify-content-between">
                  <div>
                    <span>امتیاز شما: </span>
                    <span class="text-primary">
                      <strong> {{ amount }}</strong>
                    </span>
                  </div>
                  <div>
                    <span>معادل با </span>
                    <span class="text-primary">
                      <strong> {{ tomanAmount }}</strong>
                      تومان</span>
                  </div>

                </div>
                <hr>
                <div class="d-flex justify-content-between">
                  <span>نرخ امتیاز</span>
                  <span class="text-primary">
                    <strong> {{ scoreTomanPrice }}</strong>
                    تومان</span>
                </div>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <button @click="deposit(true)" class="btn btn-sm btn-success btn-deposit">
                    واریــــز ها
                  </button>
                  <button @click="deposit(false)" class="btn btn-sm btn-danger btn-deposit">
                    برداشــت ها
                  </button>
                </div>

                <div class="mt-3">
                  <div class="mb-3 mt-2 text-black text-center">10 تراکنش اخیر</div>
                  <div v-for="item in list" :key="item" class="wallet-List-item">
                    <div class="d-flex justify-content-between first-detail">
                      <span v-if="item.isDeposit" class="text-success">
                        <i class="fa fa-arrow-up"></i> {{ item.amount }}
                      </span>
                      <span v-if="!item.isDeposit" class="text-danger"><i class="fa fa-arrow-down"></i> {{ item.amount
                      }}
                      </span>
                      <small>{{ item.dataCreated }}</small>
                    </div>
                    <div>
                      <span class="detail-description mr-3">{{
                        item.description
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import axios from "axios";
import { Loading } from "../../../public/js/Utilities";
import { closeModal } from "jenesius-vue-modal";
export default {
  props: {
    amountProp: Number,
    tomanAmountProp: String
  },
  data() {
    return {

      scoreTomanPrice: "",
      amount: "",
      tomanAmount: "",
      isDeposit: true,
      list: [],
    };
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.amount = this.amountProp;
      this.tomanAmount=this.tomanAmountProp
      this.walletCurrentUser();
      this.loadAppSetting();
    }
  },
  methods: {
    loadAppSetting() {
      axios.get("AppSetting/Get").then((res) => {

        this.scoreTomanPrice = (res.data.value.filter(
          (c) => c.keyName == "ScoreTomanPrice"
        )[0].keyValue).toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     
        
      });
    },
    walletCurrentUser() {
      Loading(1);
      axios
        .get("Wallet/GetByCurrentUser", {
          params: {
            pageId: 1,
            inPageCount: 10,
            id: null,
            UserName: null,
            dataCreated: this.dataCreated,
            isDeposit: this.isDeposit,
          },
        })
        .then((res) => {
          Loading(0);
          this.list = res.data.value.list;
        });
    },
    deposit(value) {
      this.isDeposit = value;
      this.walletCurrentUser();
    },
    closeModal() {
      closeModal()
    },

  }
};
</script>
<style>
.modal-container {
  z-index: 999 !important;
}

.btn-deposit {
  padding: 4px 40px;
}

.wallet-List-item {
  border: 1px solid #ddd;
  padding: 10px 5px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.wallet-List-item:last-child {
  margin-bottom: 0;
}

.navbar-collapse {
  background-color: transparent;
  box-shadow: none !important;
}

.first-detail {
  border-bottom: 1px dashed #eeeeee;
}

.detail-description {
  font-size: 10px;
}

.btn-deposit {
  padding: 4px 40px;
}

.wallet-List-item {
  border: 1px solid #ddd;
  padding: 10px 5px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.wallet-List-item:last-child {
  margin-bottom: 0;
}

.navbar-collapse {
  background-color: transparent;
  box-shadow: none !important;
}


.detail-description {
  font-size: 10px;
}
</style>
